(function e(t,n,r){function s(o,u){if(!n[o]){if(!t[o]){var a=typeof require=="function"&&require;if(!u&&a)return a(o,!0);if(i)return i(o,!0);var f=new Error("Cannot find module '"+o+"'");throw f.code="MODULE_NOT_FOUND",f}var l=n[o]={exports:{}};t[o][0].call(l.exports,function(e){var n=t[o][1][e];return s(n?n:e)},l,l.exports,e,t,n,r)}return n[o].exports}var i=typeof require=="function"&&require;for(var o=0;o<r.length;o++)s(r[o]);return s})({1:[function(require,module,exports){
jQuery(document).ready(function() {
  var isSP, latlng, map, marker, markerOptions, myOptions, style2, styledMapType, stylez, ua, zoom;
  latlng = new google.maps.LatLng(35.6191338, 139.7465881);
  ua = window.navigator.userAgent.toLowerCase();
  isSP = jQuery('html').hasClass('lt-480') || (ua.indexOf('iphone') > 0 || ua.indexOf('android') > 0 && ua.indexOf('mobile') > 0);
  zoom = isSP ? 14 : 16;
  myOptions = {
    zoom: zoom,
    center: latlng,
    mapTypeId: google.maps.MapTypeId.ROADMAP,
    disableDefaultUI: true,
    type: false,
    zoomControl: true,
    scrollwheel: false
  };
  stylez = [
    {
      featureType: 'water',
      stylers: [
        {
          visibility: 'simplified'
        }, {
          lightness: 37
        }, {
          saturation: 40
        }, {
          hue: '#00aaff'
        }
      ]
    }, {
      featureType: 'administrative',
      stylers: [
        {
          visibility: 'off'
        }
      ]
    }, {
      featureType: 'road',
      stylers: [
        {
          visibility: 'off'
        }
      ]
    }, {
      featureType: 'poi',
      stylers: [
        {
          visibility: 'off'
        }
      ]
    }, {
      featureType: 'transit',
      stylers: [
        {
          visibility: 'off'
        }
      ]
    }, {
      featureType: 'landscape',
      stylers: [
        {
          visibility: 'off'
        }, {
          saturation: -100
        }, {
          lightness: 100
        }
      ]
    }
  ];
  style2 = [
    {
      featureType: 'transit',
      stylers: [
        {
          saturation: -100
        }
      ]
    }, {
      featureType: 'administrative',
      stylers: [
        {
          visibility: 'off'
        }
      ]
    }, {
      featureType: 'poi',
      stylers: [
        {
          saturation: -100
        }
      ]
    }, {
      featureType: 'water',
      elementType: 'labels',
      stylers: [
        {
          visibility: 'off'
        }
      ]
    }, {
      featureType: 'water',
      stylers: [
        {
          saturation: -100
        }
      ]
    }, {
      featureType: 'road',
      elementType: 'labels',
      stylers: [
        {
          visibility: 'off'
        }
      ]
    }, {
      featureType: 'road',
      stylers: [
        {
          saturation: -100
        }
      ]
    }, {
      featureType: 'landscape',
      stylers: [
        {
          saturation: -100
        }, {
          lightness: -6
        }
      ]
    }
  ];
  map = new google.maps.Map(document.getElementById('map_canvas'), myOptions);
  markerOptions = {
    position: latlng,
    map: map,
    title: 'TSCA'
  };
  marker = new google.maps.Marker(markerOptions);
  styledMapType = new google.maps.StyledMapType(style2, myOptions);
  map.mapTypes.set('noText', styledMapType);
  map.setMapTypeId('noText');
});


},{}]},{},[1]);
